import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import UserFavoriteErrorsFactory from '../Errors/factory.js'
import UserFavoritesMappersFactory from '../Mappers/factory.js'
import HTTPUserFavoritesRepository from './HTTPUserFavoritesRepository.js'

export default class UserFavoritesRepositoriesFactory {
  static hTTPUserFavoritesRepository = ({config}) =>
    new HTTPUserFavoritesRepository({
      config,
      authenticationFetcher: FetcherFactory.httpAuthenticationFetcher({config}),
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      mapper: UserFavoritesMappersFactory.hTTPUserFavoritesResponseMapper({config}),
      unsubscribeFavoriteUserError: UserFavoriteErrorsFactory.unsubscribeFavoriteUserError
    })
}
